import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  siteChip: {
    backgroundColor: theme.palette.warning.main,
  },
  deviceChip: {
    backgroundColor: 'rgb(0, 160, 255)',
  },
  nicknameChip: {
    backgroundColor: 'rgb(119, 205, 45)',
  },
  progressDialog: {
    width: 550,
    height: 280,
  },
  gridPaper: {
    maxHeight: 'calc(100vh - 550px)',
    overflowY: 'auto',
    minHeight: 144,
  },
  filterPaper: {
    maxHeight: 76,
    overflowY: 'auto',
  },
  filterBtn: {
    '&:hover': {
      borderColor: '#000000',
    },
    borderColor: '#000000',
    color: '#000000',
  },
  audioGridPaper: {
    maxHeight: 'calc(100vh - 605px)',
    overflowY: 'auto',
    minHeight: 144,
  },
  extensionInput: {
    '& fieldset': {
      borderColor: 'green',
    },
  },
  dowloadModal: {
    maxHeight: 360,
    width: 401,
  },
}));
